import { useCallback, useMemo } from 'react'

import { mergeLibraryDocuments } from '@/features/library/lib/mergeLibraryDocuments'
import { useUserProgress } from '@/shared/contexts/UserProgress'
import { useGamificationData } from '@/shared/hooks/useGamificationData'

interface UseLibraryStoreProps {
  id?: number
}

export const useLibraryStore = ({ id }: UseLibraryStoreProps = {}) => {
  const data = useGamificationData()
  const documentsRaw = data?.documents ?? []

  const { progress } = useUserProgress()

  const getProgress = useCallback(
    (docId: number) => {
      const finished = progress?.finished_documents.includes(docId)

      return {
        finished,
        claimed: finished
      }
    },
    [progress]
  )

  const documents = useMemo(() => {
    // Duas fontes: o payload global traz os documentos SEM regra de desbloqueio,
    // e o payload por usuário traz os COM regra já avaliados para este aluno.
    // Ler só o global faria o material restrito sumir para todo mundo.
    return mergeLibraryDocuments(documentsRaw, progress?.documents).map(
      document => {
        const _progress = getProgress(document.id)
        return { ...document, _progress }
      }
    )
  }, [documentsRaw, progress])

  const document = useMemo(() => {
    if (!id) return null
    return documents.find(doc => doc.id === id)
  }, [documents, id])

  return { documents, document }
}
